import { Methods } from '@api/entry/add'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.entry.add.$get({query}) )
